import React, { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import './HelloEMSPricingNew.css';  
import { Button } from 'primereact/button';
// import { useNavigate } from "react-router-dom";
import ContactUs from "../Contact/Contact"
import { scroller } from "react-scroll";



const planNames = [
  { name: 'Free Trial', price: 0, month: 'month', employees: 10, button: 'Start Free Trial' },
  { name: 'Essential', price: '25', month: 'User/Month', employees: 20, button: 'Start Free Trial' },
  { name: 'Growth', price: '35', month: 'User/Month', employees: '21-100', button: 'Start Free Trial' },
  { name: 'Enterprise', price: '50', month: 'User/Month', employees: '100+', button: 'Start Free Trial' }
];

const featureSections = [
  {
    heading: 'Payroll',
    features: [
      { name: 'Highly customizable salary structure', status: ['✘', '✔', '✔', '✔'] },
      { name: 'Unlimited salary components', status: ['✘', '✔', '✔', '✔'] },
      { name: 'Automatic leave and attendance data integration', status: ['✘', '✔', '✔', '✔'] },
      { name: 'Increments, one-time payments, deductions, final settlements', status: ['✘', '✔', '✔', '✔'] },
      { name: 'LOP (Loss of Pay) & reversals', status: ['✘', '⧗ Partial', '✔', '✔'] },
      { name: 'Salary analytics', status: ['✘', '⧗ Partial', '✔', '✔'] },
      { name: 'Extensive reimbursement configuration', status: ['✘', '⧗ Partial', '✔', '✔'] },
      { name: 'Online reimbursement claim workflow', status: ['✘', '⧗ Partial', '✔', '✔'] },
      { name: 'Single-click payroll process with checklist', status: ['✘', '⧗ Partial', '✔', '✔'] },
      { name: 'Payslip generation and one-click distribution', status: ['⧗ Partial', '✔', '✔', '✔'] },
      { name: 'Separate reimbursement payslips', status: ['✘', '✘', '⧗ Partial', '✔'] },
      { name: 'Payroll reports', status: ['✘', '✔', '✔', '✔'] },
    ],
  },
  {
    heading: 'Leave Management',
    features: [
      { name: 'Fully customizable leave policies', status: ['⧗ Partial', '✔', '✔', '✔'] },
      { name: 'Holiday lists (location and project-based), restricted holidays', status: ['✘', '✔', '✔', '✔'] },
      { name: 'Multiple leave policies for different employee groups', status: ['✘', '⧗ Partial', '✔', '✔'] },
      { name: 'Customizable leave policy for each leave type', status: ['✘', '✔', '✔', '✔'] },
      { name: 'Automatic tracking of leave balances', status: ['⧗ Partial', '✔', '✔', '✔'] },
      { name: 'Year-end processing (lapsing, carry-forward)', status: ['✘', '✔', '✔', '✔'] },
      { name: 'Leave application and review', status: ['⧗ Partial', '✔', '✔', '✔'] },
      { name: 'Multi-level approval workflow', status: ['✘', '✔', '✔', '✔'] },
    ],
  },
  {
    heading: 'Attendance Management',
    features: [
      { name: 'Multiple/split shift management with rotation', status: ['✘', '⧗ Partial', '✔', '✔'] },
      { name: 'Easy shift rostering by managers', status: ['✘', '✔', '✔', '✔'] },
      { name: 'Automatic daily attendance processing', status: ['⧗ Partial', '✔', '✔', '✔'] },
      { name: 'Attendance regularization workflow', status: ['✘', '⧗ Partial', '✔', '✔'] },
      { name: 'Manual override facility', status: ['✘', '⧗ Partial', '✔', '✔'] },
      { name: 'Continuous absence alerts', status: ['✘', '⧗ Partial', '✔', '✔'] },
      { name: 'Month-end HR review and finalization', status: ['✘', '⧗ Partial', '✔', '✔'] },
      { name: 'Permission management for short absences (WFH, on-duty, breaks)', status: ['✘', '⧗ Partial', '✔', '✔'] },
      { name: 'Apply & approval workflows for permissions', status: ['⧗ Partial', '✔', '✔', '✔'] },
      { name: 'Detailed reports on permissions taken', status: ['✘', '⧗ Partial', '✔', '✔'] },
    ],
  },
  {
    heading: 'Employee Portal',
    features: [
      { name: 'Employee directory', status: ['✔', '✔', '✔', '✔'] },
      { name: 'Access to own documents, letters, policies, handbook, forms', status: ['⧗ Partial', '✔', '✔', '✔'] },
      { name: 'View/update own employee information', status: ['⧗ Partial', '✔', '✔', '✔'] },
      { name: 'Mobile app for employees & managers', status: ['✘', '⧗ Partial', '✔', '✔'] },
      { name: 'Leave application, cancellation, workflows', status: ['⧗ Partial', '✔', '✔', '✔'] },
      { name: 'Online leave balances and team leave info', status: ['⧗ Partial', '✔', '✔', '✔'] },
      { name: 'Leave grant/ Compoff grant workflows', status: ['✘', '✔', '✔', '✔'] },
      { name: 'Attendance regularization workflow', status: ['✘', '⧗ Partial', '✔', '✔'] },
      { name: 'Team attendance info for managers', status: ['✘', '⧗ Partial', '✔', '✔'] },
      { name: 'Detailed attendance information', status: ['⧗ Partial', '✔', '✔', '✔'] },
    ],
  },
  {
    heading: 'Dashboards & Analytics',
    features: [
      { name: 'Operational dashboards', status: ['✘', '✔', '✔', '✔'] },
      { name: 'Configurable analytical dashboards', status: ['✘', '⧗ Partial', '✔', '✔'] },
    ],
  },
  {
    heading: 'Access & User Management',
    features: [
      { name: 'Standard access management', status: ['✔', '✔', '✔', '✔'] },
      { name: 'User-definable roles & permissions', status: ['✘', '⧗ Partial', '✔', '✔'] },
      { name: 'Unlimited users', status: ['⧗ Partial', '✔', '✔', '✔'] },
      { name: 'Password policy configuration', status: ['✘', '✔', '✔', '✔'] },
      { name: 'Detailed audit logging & activity reporting', status: ['✘', '⧗ Partial', '✔', '✔'] },
      { name: 'IP restriction for application access', status: ['✘', '✘', '⧗ Partial', '✔'] },
      { name: 'Excel import & export facility', status: ['✘', '✔', '✔', '✔'] },
    ],
  },
  {
    heading: 'Expense Claims Processing',
    features: [
      { name: 'Tour advance request and review', status: ['✘', '⧗ Partial', '✔', '✔'] },
      { name: 'Online workflow for claims by employee', status: ['✘', '⧗ Partial', '✔', '✔'] },
      { name: 'Multiple approval matrix (by claim type/amount)', status: ['✘', '⧗ Partial', '✔', '✔'] },
      { name: 'Batch payment options', status: ['✘', '✘', '⧗ Partial', '✔'] },
      { name: 'Multiple payment modes', status: ['✘', '⧗ Partial', '✔', '✔'] },
    ],
  },
];

const computeSummaryStatus = (features, planIndex) => {
  const values = features.map(f => f.status[planIndex]);
  if (values.every(v => v === '✔')) return '✅';
  if (values.every(v => v === '✘')) return '✘';
  return '⧗ Partial';
};

export default function PricingTable() {
  const [expandedSections, setExpandedSections] = useState({});

  const toggleSection = (heading) => {
    setExpandedSections(prev => ({
      ...prev,
      [heading]: !prev[heading],
    }));
  };
  

    // const navigate = useNavigate();
  return (
    <div className="pricing-table-container">
      <h2 className="aboutUs-heading">
        Choose the best plan <span className="highlight-text">for you</span>
      </h2>
      <p className="pricing-subtitle">
        Great offers for small, mid and large businesses. Click to view full plan-wise feature breakdown.
      </p>

      <table className="pricing-table" >
        <thead>
          <tr>
            <th className="th-feature">Modules and Features</th>
            {planNames.map((plan, idx) => (
              <th key={idx} className="th-plan">
                <div className="plan-header-info">
                  <div className="plan-name">{plan.name}</div>
                  <div className="plan-price">₹{plan.price.toLocaleString()} / {plan.month}</div>
                  <div className="plan-employees">Up to {plan.employees} employees</div>
                </div>
                {/* <Button
                  label={plan.button}
                  severity="primary"
                  className="w-full mt-2"
                  icon="pi pi-check"
                /> */}
                <Button
  label={plan.button}
  severity="primary"
  className="w-full mt-2"
  icon="pi pi-check"
  onClick={() => {
    scroller.scrollTo("ContactUs", {
      duration: 500,
      delay: 0,
      smooth: "easeInOutQuart",
      offset: -100 // adjust so it doesn't hide behind navbar
    });
  }}
/>

              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {featureSections.map((section, sectionIdx) => {
            const summaryStatus = planNames.map((_, planIdx) =>
              computeSummaryStatus(section.features, planIdx)
            );

            return (
              <React.Fragment key={sectionIdx}>
                <tr
                  className="section-heading-row"
                  onClick={() => toggleSection(section.heading)}
                >
                  <td className="section-heading">
                    <span>{section.heading}</span>
                    <span className="icon-toggle">
                      {expandedSections[section.heading] ? <FaChevronUp /> : <FaChevronDown />}
                    </span>
                  </td>
                  {summaryStatus.map((stat, idx) => (
                    <td
                      key={idx}
                      className={`summary-status ${
                        stat === '✔️' || stat === '✅' ? 'status-available' :
                        stat === '✘' ? 'status-not-available' : 'status-partial'
                      }`}
                    >
                      {stat}
                    </td>
                  ))}
                </tr>

                {expandedSections[section.heading] &&
                  section.features.map((feature, featIdx) => (
                    <tr
                      key={featIdx}
                      className={`feature-row ${featIdx % 2 === 0 ? 'even-row' : 'odd-row'}`}
                    >
                      <td className="feature-name">{feature.name}</td>
                      {feature.status.map((val, idx) => (
                        <td
                          key={idx}
                          className={`feature-status ${
                            val === '✔' || val === '✔️' ? 'status-available' :
                            val === '✘' ? 'status-not-available' : 'status-partial'
                          }`}
                        >
                          {val}
                        </td>
                      ))}
                    </tr>
                  ))}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>

      <p className="legend-text">
        ✅ = Available | ✘ = Not Available | ⧗ Partial = Partial / Limited
      </p>
    </div>
  );
}
